import { CommonApi } from '@app/modules/core/api/common.api';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorMappingService {
  private nonFlashMessageCodes: CommonApi.MessageCode[] = [
    CommonApi.MessageCode.invalidUser,
    CommonApi.MessageCode.invalidPassword,
    CommonApi.MessageCode.accountLocked,
    CommonApi.MessageCode.triesExceeded,
    CommonApi.MessageCode.invalidUid,
    CommonApi.MessageCode.invalidQCardNumber,
    CommonApi.MessageCode.invalidPassword,
    CommonApi.MessageCode.invalidInput,
    CommonApi.MessageCode.resourceNotFound,
    CommonApi.MessageCode.finAmountAboveMax,
    CommonApi.MessageCode.finAmountBelowMin,
    CommonApi.MessageCode.incorrectOneTimeCode,
    CommonApi.MessageCode.exceededNoOfAttempt,
    CommonApi.MessageCode.declined,
    CommonApi.MessageCode.expired,
    CommonApi.MessageCode.transactionFullyPaid
  ];

  private _map = new Map<CommonApi.MessageCode | string, string>();

  constructor(private translateService: TranslateService) {
    this._map.set(
      CommonApi.MessageCode.invalidInput,
      'errors.server.password.incorrect'
    );
    this._map.set(
      CommonApi.MessageCode.invalidUser,
      'errors.server.password.incorrect'
    );
    this._map.set(
      CommonApi.MessageCode.invalidPassword,
      'errors.server.password.incorrect'
    );
    this._map.set(
      CommonApi.MessageCode.accountLocked,
      'errors.server.login.accountLocked'
    );
    this._map.set(
      CommonApi.MessageCode.triesExceeded,
      'errors.server.login.attemptsExceeded'
    );
    this._map.set(
      CommonApi.MessageCode.unauthorized,
      'errors.server.userVerify.unauthorized'
    );
    this._map.set(
      CommonApi.MessageCode.finAmountAboveMax,
      'errors.server.newPurchase.aboveMaxFinance'
    );
    this._map.set(
      CommonApi.MessageCode.finAmountBelowMin,
      'errors.server.newPurchase.belowMinFinance'
    );
    this._map.set(
      CommonApi.MessageCode.incorrectOneTimeCode,
      'errors.server.finalizePurchase.incorrectOtc'
    );
    // this._map.set(
    //   CommonApi.MessageCode.exceededNoOfAttempt,
    //   'errors.server.login.attemptsExceeded'
    // );
  }

  lookupCode(messageCode: CommonApi.MessageCode | string): string {
    return this._map.get(messageCode);
  }

  lookupMessage(messageCode: CommonApi.MessageCode | string) {
    const code = this.lookupCode(messageCode);
    if (code == null) {
      return null;
    }
    return this.translateService.instant(code);
  }

  showAsFlash(code: CommonApi.MessageCode): boolean {
    return !this.nonFlashMessageCodes.includes(code);
  }
}
